/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PositiveSecurityPolicyModule
 */

/**
 * @fileoverview
 *     File contains Ajs dependency tokens for Positive Security Policy factories.
 * @author Zhiqian Liu
 */

/**
 * Ajs dependency token for PositiveSecurityPolicy item.
 */
export const POSITIVE_SECURITY_POLICY_ITEM_TOKEN = 'PositiveSecurityPolicyItem';

/**
 * Ajs dependency token for PositiveSecurityPolicy collection.
 */
export const POSITIVE_SECURITY_POLICY_COLLECTION_TOKEN = 'PositiveSecurityPolicyCollection';

/**
 * Ajs dependency token for PositiveSecurityParams config item.
 */
export const POSITIVE_SECURITY_PARAMS_CONFIG_ITEM = 'PositiveSecurityParamsConfigItem';
